import * as Yup from 'yup';
import { SPACE_ALPHANUMERIC_REGEX } from 'Utils';
import { TFunction } from 'i18next';
import { getTranslationValidationHandling } from 'Hooks/query-hooks/helper';

const nameSchema = (listName: string, validationT: (s: string, options?: any) => string) => {
    return Yup.string()
        .required(validationT('required', { field: listName }))
        .matches(SPACE_ALPHANUMERIC_REGEX, validationT('alphanumeric', { field: listName }))
        .trim(validationT('noLeadingTrailingSpaces'))
        .strict()
        .min(1)
        .max(128, validationT('maxLength', { field: listName, charCount: 128 }));
};

const descriptionSchema = (t: TFunction, validationT: (s: string, options?: any) => string) => {
    return Yup.string()
        .optional()
        .max(150, validationT('maxLength', { field: t('List Description'), charCount: 150 }));
};

export const addListValidationSchema = (t: TFunction) => {
    const listName = t('List Name');
    const validationT = getTranslationValidationHandling(t);

    return Yup.object({
        name: nameSchema(listName, validationT),
        listType: Yup.string().required(validationT('required', { field: listName })),
        description: descriptionSchema(t, validationT)
    });
};

export const editListValidationSchema = (t: TFunction) => {
    const listName = t('List Name');
    const validationT = getTranslationValidationHandling(t);

    return Yup.object({
        name: nameSchema(listName, validationT),
        description: descriptionSchema(t, validationT)
    });
};
